import { ChefHat } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

const Field = ({ label, hint, value, onChange, testid }) => (
  <div className="space-y-1">
    <Label>{label}</Label>
    <div className="flex items-center gap-2">
      <Input type="number" min={1} max={480} value={value ?? ''} className="w-24" data-testid={testid}
        onChange={(e) => onChange(e.target.value === '' ? null : parseInt(e.target.value, 10))} />
      <span className="text-sm text-muted-foreground">minutos</span>
    </div>
    <p className="text-xs text-muted-foreground">{hint}</p>
  </div>
);

// Cuándo la cocina y la TV marcan un pedido como atrasado
export const KitchenTimesCard = ({ settings, onChange, onSave, saving }) => {
  const warn = settings.kitchen_warning_minutes;
  const crit = settings.kitchen_critical_minutes;
  const invalid = warn && crit && crit <= warn;
  return (
    <Card data-testid="kitchen-times-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><ChefHat className="w-5 h-5" />Tiempos de cocina</CardTitle>
        <CardDescription>Los mismos para la pantalla de cocina y la TV.</CardDescription>
      </CardHeader>
      <CardContent className="grid sm:grid-cols-2 gap-6">
        <Field label="Atrasado (amarillo)" hint="Desde este tiempo el pedido se marca en amarillo" value={warn}
          onChange={(v) => onChange({ ...settings, kitchen_warning_minutes: v })} testid="kitchen-warning-input" />
        <Field label="Muy atrasado (rojo)" hint="Desde este tiempo el pedido se marca en rojo" value={crit}
          onChange={(v) => onChange({ ...settings, kitchen_critical_minutes: v })} testid="kitchen-critical-input" />
        {invalid && <p className="sm:col-span-2 text-sm text-destructive" data-testid="kitchen-times-error">"Muy atrasado" tiene que ser mayor que "Atrasado".</p>}
        <div className="sm:col-span-2">
          <Button onClick={onSave} disabled={saving || invalid} data-testid="kitchen-times-save">Guardar tiempos</Button>
        </div>
      </CardContent>
    </Card>
  );
};
